import { useState } from 'react';

import { type TemplateRecord } from '../types';

export const useDeleteModal = () => {
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
    const [templateToDelete, setTemplateToDelete] = useState<TemplateRecord | null>(null);

    const openDeleteModal = (templateRecord: TemplateRecord) => {
        setTemplateToDelete(templateRecord);
        setDeleteModalIsOpen(true);
    };

    const closeDeleteModal = () => {
        setDeleteModalIsOpen(false);
        setTemplateToDelete(null);
    };

    return {
        deleteModalIsOpen,
        openDeleteModal,
        templateToDelete,
        closeDeleteModal
    };
};
